<template>
  <div class='EnbProdutos'>
    <prod-action/>
    <NaveProdMobile/>
    <div class="input-search-mobile">
      <input-search
      :placeholder="Empresa.modelo === 'Modelo 03' ? 'Nome do imóvel' : 'Nome do produto'"
      action="SearchNameProdPainel"
      />
    </div>
    <ProdActionMobile/>
    <prods-header/>
    <enb-vazio
    v-if="!Produtos.length && !GlobalLoading"
    text="Nenhum registro encontrado!"
    />
    <div class="cont-prod" @scroll="run">
      <list-item
      v-for="(data, key) in Produtos"
      :key="key"
      :data="data"
      :chave="key"
      />
      <div class="bottom">
        <vue-spinner v-if="load" size="45"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProdsHeader from './Header/ProdsHeader'
import ListItem from './Itens/ListItem'
import ProdAction from './Header/ProdAction'
import { VueSpinner } from 'vue3-spinners'
import EnbVazio from '../EnbVazio'
import NaveProdMobile from './Nave/NaveProdMobile'
import InputSearch from '../Search/InputSearch'
import ProdActionMobile from './Header/ProdActionMobile'
export default {
  name: 'EnbProdutos',
  components: { ProdsHeader, ListItem, ProdAction, VueSpinner, EnbVazio, NaveProdMobile, InputSearch, ProdActionMobile },
  data () {
    return {
      scroll: {
        position: 0,
        height: 1
      },
     load: false
    }
  },
  computed: {
    ...mapGetters(['Produtos', 'FilterProdPainel', 'GlobalLoading', 'Empresa'])
  },
  methods: {
    ...mapActions(['GetProduct', 'Loading']),
    run (e) {
      this.scroll = {
        position: (e.target.offsetHeight + e.target.scrollTop),
        height: e.target.scrollHeight
      }
      if((this.scroll.height - this.scroll.position) <= 1) {
        //busca mais produtos
        this.load = true
        setTimeout(() => {
          this.GetProduct({ params : {
            last: this.Produtos[this.Produtos.length - 1].id,
            limit: 15,
            categoria: this.FilterProdPainel.categoria,
            status: this.FilterProdPainel.status
          }, init: false})
          .then(() => {
            this.load = false
          })
        }, 2000)
      }
    }
  },
  created () {
    this.Loading(true)
    this.GetProduct({ params: { last: 0, limit: 15, categoria: this.FilterProdPainel.categoria, status: this.FilterProdPainel.status }, init: true })
      .then(res => {
        this.produtos = res
        this.Loading(false)
      })
  }
}
</script>

<style scoped>
.EnbProdutos {
  width: 100%;
  height: 100%;
}

.cont-prod {
  width: 98%;
  height: 80%;
  overflow: auto;
  padding: 1%;
  padding-top: 0;
}

.bottom {
  height: 50px;
}

@media (max-width: 500px) {
  .cont-prod {
    height: 40%;
  }
}

@media screen and (min-width: 500px) {
  .input-search-mobile {
    display: none;
  }
}
</style>
